// Traduções — Espanhol. Chave = texto usado no t() (ver src/i18n.js).
const es = {
  'Welcome back': 'Bienvenido de nuevo',
  'Yes': 'Sí',
  'No': 'No',
  'Dashboard': 'Panel de control',
  "We've missed you": 'Te hemos extrañado',
  'Users': 'Usuarios',
  'User': 'Usuario',
  'user': 'usuario',
  'judge': 'juez',
  'producer': 'productor',
  'Edit User': 'Editar usuario',
  'Edit Producer': 'Editar productor',
  'Edit Judge': 'Editar juez',
  'Add User': 'Añadir usuario',
  'Add Producer': 'Añadir productor',
  'Add Judge': 'Añadir juez',
  'Name': 'Nombre',
  'Full Name': 'Nombre completo',
  'Lastname': 'Apellido',
  'E-mail': 'Correo electrónico',
  'Language': 'Idioma',
  'Languages': 'Idiomas',
  'Role': 'Rol',
  'Actions': 'Acciones',
  'New User': 'Nuevo usuario',
  'Save': 'Guardar',
  'Save Changes': 'Guardar cambios',
  'Producer': 'Productor',
  'Judge': 'Juez',
  'Admin': 'Administrador',
  'Password': 'Contraseña',
  'Confirm Password': 'Confirmar contraseña',
  'Portuguese': 'Portugués',
  'English': 'Inglés',
  'Spanish': 'Español',
  'Italian': 'Italiano',
  'French': 'Francés',
  'Close': 'Cerrar',
  'Occured an Error': 'Ocurrió un error',
  'Done': 'Hecho',
  'User registred successfully': 'Usuario registrado exitosamente',
  'Required field': 'Campo obligatorio',
  'User updated successfully': 'Usuario actualizado con éxito',
  'Product registered successfully': 'Producto registrado con éxito',
  'Registration updated successfully': 'Registro actualizado con éxito',
  "Farm's Name": 'Nombre de la granja',
  "Farm's Legal Representative": 'Representante legal de la granja',
  'Country': 'País',
  'State': 'Estado',
  'Status': 'Estado',
  'Active': 'Activo',
  'Inactive': 'Inactivo',
  'Producers': 'Productores',
  'Judges': 'Jueces',
  'Website': 'Sitio web',
  'Phone Number': 'Número de teléfono',
  'Cellphone Number': 'Número de celular',
  'Document Number': 'Número de documento',
  'RG': 'RG',
  'CPF': 'RUT',
  'CNPJ': 'CNPJ',
  'Passport': 'Pasaporte',
  'ID Document Type': 'Tipo de documento de identificación',
  'City': 'Ciudad',
  'Zip-Code': 'Código Postal',
  'Producer updated successfully': 'Productor actualizado exitosamente',
  'Judge updated successfully': 'Juez actualizado exitosamente',
  'Producer registered successfully': 'Productor registrado exitosamente',
  'Judge registered successfully': 'Juez registrado exitosamente',
  'Curator updated successfully': 'Curador actualizado exitosamente',
  'Curator registered successfully': 'Curador registrado exitosamente',
  'A confirmation e-mail was sent to the registered e-mail address.':
    'Se envió un correo electrónico de confirmación a la dirección registrada.',
  'Producer Registration': 'Registro de productor',
  'Judge Registration': 'Registro de juez',
  'New Producer': 'Nuevo productor',
  'New Judge': 'Nuevo juez',
  'Subscribe another product': 'Suscribir otro producto',
  'Register new product': 'Registrar nuevo producto',
  'Edit Registration': 'Editar registro',
  'Registration Detail': 'Detalle del registro',
  "Product's Name": 'Nombre del producto',
  'Certificate Type': 'Tipo de certificado',
  'Municipal Certificate': 'Certificado municipal',
  'State Certificate': 'Certificado estatal',
  'Federal Certificate': 'Certificado federal',
  'Selo Arte': 'Sello Arte',
  'Art Stamp': 'Sello artístico',
  "Products's Characteristics": 'Características del producto',
  'Group': 'Grupo',
  'Origin': 'Origen',
  'Creation Date': 'Fecha de creación',
  'Update Date': 'Fecha de actualización',
  'Milk Type': 'Tipo de leche',
  'Raw': 'Cruda',
  'Pasteurized': 'Pasteurizada',
  'Manufacturing Date': 'Fecha de fabricación',
  'Dough Treatment': 'Tratamiento de la masa',
  'Rind Type': 'Tipo de corteza',
  'Registrations': 'Registros',
  'New Product Registration': 'Registro de nuevo producto',
  'Certificate': 'Certificado',
  'Code': 'Código',
  'Paid': 'Pagado',
  'Orders': 'Pedidos',
  'Orders History': 'Historial de pedidos',
  'Administrative': 'Administrativo',
  'Brazil': 'Brasil',
  'Italy': 'Italia',
  'United States': 'Estados Unidos',
  'France': 'Francia',
  'Germany': 'Alemania',
  'Spain': 'España',
  'Approved': 'Aprobado',
  'Failed': 'Rechazado',
  'Reprovado': 'Rechazado',
  'Pending': 'Pendiente',
  'Occupation': 'Ocupación',
  'of': 'de',
  'more than': 'más de',
  'Proficiency Languages': 'Idiomas con competencia',
  'Male': 'Masculino',
  'Female': 'Femenino',
  'Other': 'Otro',
  'Nationality': 'Nacionalidad',
  'Gender': 'Género',
  'Educational Background': 'Formación educativa',
  'Professional Activity': 'Actividad profesional',
  'Company': 'Empresa',
  'Add File': 'Añadir archivo',
  'Delete': 'Eliminar',
  'Are you sure that you want to delete': '¿Estás seguro de que deseas eliminar',
  'Item deleted successfully!': '¡Elemento eliminado con éxito!',
  'Cart': 'Carrito',
  'Description': 'Descripción',
  'Amount': 'Cantidad',
  'Go to payment': 'Ir al pago',
  'Items': 'Artículos',
  'Remove': 'Eliminar',
  'Order Summary': 'Resumen del pedido',
  'Contest Parameters': 'Parámetros del concurso',
  'Payment Expiring Date': 'Fecha de vencimiento del pago',
  'Logout': 'Cerrar sesión',
  'ID da Propriedade': 'ID de la propiedad',
  'Passaporte': 'Pasaporte',
  'Approve': 'Aprobar',
  'Disapprove': 'Rechazar',
  'Invoices': 'Facturas',
  'Order number': 'Número de pedido',
  'Order Number': 'Número de Pedido',
  'Order total': 'Total del pedido',
  'Cash Credit Card': 'Tarjeta de crédito en efectivo',
  'Credit card in': 'Tarjeta de crédito en',
  'installments': 'cuotas',
  'Credit Card': 'Tarjeta de crédito',
  'Payment method': 'Método de pago',
  'Payment Method': 'Método de Pago',
  'YOUR NAME': 'TU NOMBRE',
  'Card Number': 'Número de tarjeta',
  'Card Name': 'Nombre en la tarjeta',
  'Valid Thru': 'Válido hasta',
  'Installments': 'Cuotas',
  'Finish Order': 'Finalizar pedido',
  'Finish Payment': 'Finalizar pago',
  'Válido até às': 'Válido hasta las',
  'Copy Pix Code': 'Copiar código Pix',
  'Payment Info': 'Información de pago',
  'Pix à vista': 'Pix a la vista',
  'Boleto à vista': 'Boleto a la vista',
  'Order': 'Pedido',
  'Payment Date': 'Fecha de pago',
  'Vencida': 'Vencida',
  'Aguardando pagamento': 'Esperando pago',
  'Expiring Date': 'Fecha de vencimiento',
  'Expired in': 'Venció en',
  'Print': 'Imprimir',
  'Order Completed': 'Pedido completado',
  'Inscricao': 'Inscripción',
  'Log In': 'Iniciar sesión',
  'Sign up': 'Regístrate',
  'Remember me': 'Recuérdame',
  'Change my password': 'Cambiar mi contraseña',
  'Back to login': 'Volver a iniciar sesión',
  'Choose your role': 'Elige tu rol',
  'Paying Method': 'Método de pago',
  'CartaoCredito': 'TarjetaDeCrédito',
  'Order Details': 'Detalles del pedido',
  'Click on the link in this e-mail to validate your registration.':
    'Haz clic en el enlace de este correo para validar tu registro.',
  'Register': 'Registrar',
  'Successful Registration': 'Registro exitoso',
  'E-mail inválido': 'Correo electrónico inválido',
  'Campo obrigatório': 'Campo obligatorio',
  'New Password': 'Nueva contraseña',
  'Password changed successfully': 'Contraseña cambiada con éxito',
  'Change password': 'Cambiar contraseña',
  'Delete file': 'Eliminar archivo',
  'days': 'días',
  'Product Information': 'Información del producto',
  'Review Sheet': 'Ficha de evaluación',
  'Review Sheets': 'Fichas de evaluación',
  'Maturation Days': 'Días de maduración',
  "Product's Code": 'Código del producto',
  'Estragado': 'Estropeado',
  'Péssimo': 'Pésimo',
  'Ruim': 'Malo',
  'Insuficiente': 'Insuficiente',
  'Razoável': 'Razonable',
  'Suficiente': 'Suficiente',
  'Bom': 'Bueno',
  'Ótimo': 'Muy bueno',
  'Excelente': 'Excelente',
  'Perfeito': 'Perfecto',
  'Send Review': 'Enviar evaluación',
  'General Aspect': 'Aspecto general',
  'Color': 'Color',
  'Texture': 'Textura',
  'Odor': 'Olor',
  'Scent': 'Aroma',
  'Consistency': 'Consistencia',
  'Flavor': 'Sabor',
  'Payment': 'Pago',
  'Title / Aspect': 'Título / Aspecto',
  'Title': 'Título',
  'Aspect': 'Aspecto',
  'Max Rating': 'Calificación máxima',
  'Weight': 'Ponderación',
  'Products': 'Productos',
  'Product': 'Producto',
  'Registration': 'Registro',
  'Cancel': 'Cancelar',
  'Add': 'Añadir',
  'Ricotta': 'Ricota',
  'Requeijão em Barra': 'Requesón en barra',
  'Requeijão Moreno': 'Requesón moreno',
  'Fresco sem tratamento': 'Fresco sin tratamiento',
  'Com Aquecimento': 'Con calentamiento',
  'Sem Aquecimento': 'Sin calentamiento',
  'Cru': 'Cruda',
  'Pausterizado': 'Pasteurizada',
  'Vaca': 'Vaca',
  'Cabra': 'Cabra',
  'Ovelha': 'Oveja',
  'Búfala': 'Búfala',
  'Outro': 'Otro',
  'Event': 'Evento',
  'Awards Info': 'Información de premios',
  'Contest Phase': 'Fase del concurso',
  'Contest Phases': 'Fases del concurso',
  'Max Grade': 'Calificación máxima',
  'Add question': 'Añadir pregunta',
  'Contest Start Date': 'Fecha de inicio del concurso',
  'Contest': 'Concurso',
  'Payment Status': 'Estado del pago',
  'Processando pagamento': 'Procesando pago',
  'Não pago': 'No pagado',
  'Add phase': 'Añadir fase',
  'Contest Phase Name': 'Nombre de la fase del concurso',
  'Contest Phase Order': 'Orden de la Fase del Concurso',
  'Phase Order': 'Orden de la fase',
  'Contest Tables': 'Mesas del concurso',
  'Shuffle Tables': 'Sortear mesas',
  'Shuffle Judges': 'Sortear Jueces',
  'Table Details': 'Detalles de la mesa',
  'Registrations by Producers': 'Registros por productores',
  'Your Reviews': 'Tus evaluaciones',
  'New Curator': 'Nuevo curador',
  'Curators': 'Curadores',
  'Edit Curator': 'Editar curador',
  'Phone': 'Teléfono',
  'Pending Payment': 'Pago pendiente',
  'Reports': 'Informes',
  'Table': 'Mesa',
  'Free': 'Libre',
  'Move': 'Mover',
  'Judge moved successfully': 'Juez movido con éxito',
  'Product moved successfully': 'Producto movido con éxito',
  'Product reviewed successfully': 'Producto evaluado con éxito',
  'Return': 'Regresar',
  'Search': 'Buscar',
  'Filter': 'Filtrar',
  'Table QR Codes': 'Códigos QR de la mesa',
  "Print Judge's List": 'Imprimir lista de jueces',
  "Print Product's List": 'Imprimir lista de productos',
  'Print QR Codes': 'Imprimir códigos QR',
  'Untie Priority': 'Eliminar prioridad',
  'Real Time': 'Tiempo real',
  'Start Phase': 'Iniciar fase',
  'End Phase': 'Finalizar fase',
  'Average Score': 'Calificación promedio',
  'Reviews': 'Reseñas',
  'Total Reviews': 'Total de reseñas',
  'Total Products': 'Total de productos',
  'Total Judges': 'Total de jueces',
  'Reset Phase': 'Reiniciar fase',
  'Overall Awards Results': 'Resultados generales de premios',
  'Overall Result': 'Resultado general',
  'Category Result': 'Resultado por categoría',
  'Score': 'Puntuación',
  'Export': 'Exportar',
  'Qualified by Phase': 'Clasificado por fase',
  'General': 'General',
  'Second Phase': 'Segunda fase',
  'Refresh': 'Actualizar',
  'Selected': 'Seleccionado',
  'Not selected': 'No seleccionado',
  'Deselect': 'Deseleccionar',
  'Quantitative Assessment Form': 'Formulario de evaluación cuantitativa',
  'Selecionados': 'Seleccionados',
  'Select Judge': 'Seleccionar juez',
  'Export Grades': 'Exportar calificaciones',
  'Reset Event': 'Reiniciar evento',
  'Reopen Phase': 'Reabrir fase',
  'Select a Category': 'Seleccionar una categoría',
  'Counting votes': 'Contando votos',
  'Heating': 'Calentamiento',
  'Heated': 'Calentado',
  'No heated': 'No calentado',
  'Comment': 'Comentario',
  'Table Leader': 'Líder de la mesa',
  'Set Table Leader': 'Establecer líder de la mesa',
  'Table Leader Setup': 'Configuración del líder de la mesa',
  'Move Judge': 'Mover juez',
  'Details': 'Detalles',
  'Warning': 'Advertencia',
  'Change Table Leader': 'Cambiar líder de la mesa',
  'Scan QR Code': 'Escanear código QR',
  'Loading': 'Cargando',
  'Product Status': 'Estado del producto',
  'Shipped': 'Enviado',
  'Edit': 'Editar',
  'Unknown': 'Desconocido',
  'Able': 'Apto',
  'Unable': 'No apto',
  'Print Certificate': 'Imprimir certificado',
  'Print Seal': 'Imprimir sello',
  'Download Certificate': 'Descargar certificado',
  'Contest Started': 'Concurso iniciado',
  'Table Number': 'Número de mesa',
  'Current Contest Phase': 'Fase actual del concurso',
  "Table's Leader Veredic": 'Conclusión del líder de mesa',
  'Grade': 'Calificación',
  'Print Registration Form': 'Imprimir formulario de registro',
  'Page Not Found': 'Página no encontrada',
  'Print Review Report': 'Imprimir informe de evaluación',
  'Reviews by Attributes': 'Evaluaciones por atributos',
  'Move Product': 'Mover producto',
  'Profession': 'Profesión',
  'Registered Products': 'Productos registrados',
  'Registered products management': 'Gestión de productos inscritos',
  'New Registration': 'Nuevo registro',
  'Active Contest': 'Concurso activo',
  'Edition': 'Edici\u00f3n',
  'Registration Fee:': 'Tasa de inscripci\u00f3n:',
  'Payment enabled': 'Pago habilitado',
  'No active contest at this time.': 'Ning\u00fan concurso activo en este momento.',
  'My Registration': 'Mi inscripci\u00f3n',
  'Open': 'Abierta',
  'Registration date:': 'Fecha de inscripción:',
  'Registration Date': 'Fecha de inscripción',
  'Total value:': 'Valor total:',
  "You haven't started your registration yet.": 'A\u00fan no has iniciado tu inscripci\u00f3n en este concurso.',
  'Starting...': 'Iniciando...',
  'Products Registrations': 'Productos Inscritos',
  'Start Registration': 'Iniciar inscripción',
  'My Registered Products': 'Mis productos inscritos',
  'Register Product': 'Inscribir producto',
  'Start your registration to add products.': 'Inicia tu inscripci\u00f3n para agregar productos.',
  'No products registered yet.': 'Ning\u00fan producto inscrito a\u00fan.',
  'Register first product': 'Inscribir primer producto',
  'Could not load registration data.': 'No se pudieron cargar los datos de la inscripci\u00f3n.',
  'Error starting registration. Please try again.': 'Error al iniciar la inscripci\u00f3n. Int\u00e9ntalo de nuevo.',
  'Product Detail': 'Detalle del producto',
  'Product Name': 'Nombre del producto',
  'Category / Group': 'Categor\u00eda / Grupo',
  'None': 'Ninguno',
  'Additional Information': 'Informaci\u00f3n adicional',
  'Dates': 'Fechas',
  'Registraded in': 'Registrado el',
  'Classification Answers': 'Respuestas de clasificaci\u00f3n',
  'Subcategory': 'Subcategor\u00eda',
  'Registered': 'Inscrito',
  'Error saving changes.': 'Error al guardar los cambios.',
  'Could not load product data.': 'No se pudieron cargar los datos del producto.',
  'Product not found.': 'Producto no encontrado.',
  'cert.errCarregarPremiacao': 'Error al cargar información de premiación.',
  'cert.semPremiacao': 'Este producto no tiene premiación registrada.',
  'cert.selecionarFase': 'Seleccionar fase',
  'cert.semTemplate': 'No hay plantilla de certificado configurada para esta premiación.',
  'cert.gerando': 'Generando...',
  'cert.errGerarCertificado': 'Error al generar el certificado. Inténtalo de nuevo.',
  'cert.comFundo': 'Imprimir con fondo',
  'cert.semFundo': 'Imprimir sin fondo',
  'Edit product data': 'Editar datos del producto',
  'No fields configured in the form of this subcategory.':
    'Ningún campo configurado en el formulario de esta subcategoría.',
  'Saving...': 'Guardando...',
  'Awarded Product': 'Producto premiado',
  "Producer's Name": 'Nombre del productor',
  'Product Registration': 'Registro de producto',
  'User Profile Data': 'Datos del perfil del usuario',
  'Authenticated user information': 'Información del usuario autenticado',
  'Edit Profile': 'Editar perfil',
  'Email': 'Correo electrónico',
  'Global role': 'Rol global',
  'Role in contest': 'Rol en el concurso',
  'Current Contest': 'Concurso actual',
  'Year': 'Año',
  'Closed': 'Cerradas',
  'Organization': 'Organización',
  'No active contest': 'Ningún concurso activo',
  'Judge Panel': 'Panel del jurado',
  'My Tables': 'Mis mesas',
  'Judge Invite': 'Invitación de jurado',
  'Accept Invite': 'Aceptar invitación',
  'Decline': 'Rechazar',
  'Back to my tables': 'Volver a mis mesas',
  'Back to table': 'Volver a la mesa',
  'No tables assigned yet': 'Sin mesas asignadas aún',
  'Your evaluation tables will appear here when assigned by the organizer.':
    'Tus mesas de evaluación aparecerán aquí cuando sean asignadas por el organizador.',
  'Overall evaluation progress': 'Progreso general de evaluación',
  'evaluated': 'evaluados',
  'Evaluation progress': 'Progreso de evaluación',
  'All products evaluated in this table!': '¡Todos los productos evaluados en esta mesa!',
  'No products assigned to this table yet.': 'Aún no hay productos asignados a esta mesa.',
  'Evaluation Form': 'Ficha de evaluación',
  'Already evaluated — you can revise': 'Ya evaluado — puedes revisar',
  'Scores': 'Puntuaciones',
  'Disqualify product': 'Descalificar producto',
  'Disqualify': 'Descalificar',
  'Cancel disqualification': 'Cancelar descalificación',
  'Confirm disqualification': 'Confirmar descalificación',
  'Reason for disqualification': 'Motivo de descalificación',
  'Disqualification reason is required.': 'El motivo de descalificación es obligatorio.',
  'Save evaluation': 'Guardar evaluación',
  'Evaluation saved!': '¡Evaluación guardada!',
  'Evaluated': 'Evaluado',
  'Score required': 'Puntuación requerida',
  'Error saving evaluation. Please try again.': 'Error al guardar la evaluación. Por favor, inténtalo de nuevo.',
  'Could not load your tables. Please try again later.':
    'No se pudieron cargar tus mesas. Por favor, inténtalo más tarde.',
  'Could not load table data. Please try again later.':
    'No se pudieron cargar los datos de la mesa. Por favor, inténtalo más tarde.',
  'Could not load evaluation form. Please try again later.':
    'No se pudo cargar la ficha de evaluación. Por favor, inténtalo más tarde.',
  'Contest Categories': 'Categorías del concurso',
  'Add Category': 'Añadir categoría',
  'Categories': 'Categorías',
  'Category': 'Categoría',
  'Category Registration': 'Registro de categoría',
  'New Category': 'Nueva categoría',
  'Edit Category': 'Editar categoría',
  'Product Categories': 'Categorías de productos',
  'Search CEP': 'Buscar Código Postal',
  'Health Service Number': 'Número de servicio sanitario',
  'Health Certificate': 'Certificado sanitario',
  'Duplicate': 'Duplicar',
  'Download Lab Analysis': 'Descargar análisis de laboratorio',
  'Download Curation': 'Descargar curaduría',
  'Error downloading file': 'Error al descargar el archivo',
  'Attach Analysis': 'Adjuntar análisis',
  'Receive': 'Recibir',
  'Receive Product': 'Recibir producto',
  'Validate Product': 'Validar producto',
  'Separate Product': 'Separar producto',
  'In Analysis': 'En análisis',
  'Health Service': 'Servicio Sanitario',
  'Regional Innovation': 'Innovación regional',
  'Lab Analyst': 'Analista de laboratorio',
  'Inspect Product': 'Inspeccionar producto',
  'Send to Analysis': 'Enviar a análisis',
  'Send Product': 'Enviar producto',
  'Transfer Product': 'Transferir producto',
  'Receive Transfered Product': 'Recibir producto transferido',
  'Analysed': 'Analizado',
  'Terms of Service and Privacy Policy': 'Términos de servicio y política de privacidad',
  'By continuing, you agree to the Terms of Service and Privacy Policy.':
    'Al continuar, aceptas los términos de servicio y la política de privacidad.',
  'I agree': 'Estoy de acuerdo',
  "I've read and agreed to the terms and privacy policy":
    'He leído y aceptado los términos y la política de privacidad',
  'Profile': 'Perfil',
  'Themes': 'Temas',
  'View Analysis': 'Ver análisis',
  'Select All': 'Seleccionar todo',
  'Question Order': 'Orden de preguntas',
  'New Review Sheet': 'Nueva ficha de evaluación',
  'Edit Review Sheet': 'Editar ficha de evaluación',
  'Print Sample Submission Procedure': 'Imprimir procedimiento de envío de muestras',
  'Remarks': 'Observaciones',
  'Reset Password': 'Restablecer contraseña',
  'History': 'Historial',
  'Attach Product Analysis': 'Adjuntar análisis de producto',
  'Photographic Record': 'Registro fotográfico',
  'View Record': 'Ver registro',
  'Registrations closed': 'Inscripciones cerradas',
  'Generate Certificates': 'Generar certificados',
  'First Position': 'Primera posición',
  'Second Position': 'Segunda posición',
  'Third Position': 'Tercera posición',
  'Position Award': 'Premio por posición',
  'Print Certificates': 'Imprimir Certificados',
  'Training': 'Entrenamiento',
  'Training Mode': 'Modo de entrenamiento',
  'Scan the QR Code on the product label to start the evaluation.':
    'Escanea el código QR en la etiqueta del producto para iniciar la evaluación.',
  'Competition in Progress': 'Concurso en Progreso',
  'Good morning': 'Buenos días',
  'Good afternoon': 'Buenas tardes',
  'Good evening': 'Buenas noches',
  'Welcome to your judge panel': 'Bienvenido a tu panel de jurado',
  'Your next phase': 'Tu próxima fase',
  'You have {{n}} phases scheduled': 'Tienes {{n}} fases programadas',
  '{{fase}} starts at {{date}}.': '{{fase}} comienza el {{date}}.',
  "Check the schedule for what's coming up.": 'Consulta la agenda para ver lo que viene.',
  'Phase': 'Fase',
  'My schedule': 'Mi agenda',
  'Final score': 'Nota final',
  'Position': 'Posición',
  'Awarded': 'Premiado',
  'Disqualified': 'Descalificado',
  'evaluations': 'evaluaciones',
  'Performance by attribute': 'Desempeño por atributo',
  'No attribute scores to display.': 'No hay notas por atributo para mostrar.',
  'Detailed scores': 'Notas detalladas',
  'Attribute': 'Atributo',
  'My score': 'Mi nota',
  'My product': 'Mi producto',
  'Group average': 'Promedio del grupo',
  'Comment from the table': 'Comentario de la mesa',
  'Team recommendation': 'Recomendación del equipo',
  'Back': 'Volver',
  'Waiting to start': 'Esperando inicio',
  'In progress': 'En curso',
  'Counting': 'En recuento',
  'Finalized': 'Finalizada',
  'Phase {{order}}': 'Fase {{order}}',
  'Expected for {{date}}': 'Previsto para {{date}}',
  'No date scheduled yet': 'Sin horario previsto aún',
  'Started on {{date}}': 'Iniciada el {{date}}',
  'Table {{n}}': 'Mesa {{n}}',
  'Table not assigned yet': 'Mesa aún no asignada',
  "You're all set for {{concurso}}. We'll let you know as soon as you're assigned to a table.":
    'Todo listo para {{concurso}}. Te avisaremos en cuanto seas asignado a una mesa.',
  "You're all set. We'll let you know as soon as you're assigned to a table.":
    'Todo listo. Te avisaremos en cuanto seas asignado a una mesa.',
  'Wait for the organizer to draw the tables.': 'Espera a que el organizador realice el sorteo de las mesas.',
  'Once assigned, your tables will appear here automatically.':
    'Una vez asignadas, tus mesas aparecerán aquí automáticamente.',
  'On the day of the competition, scan the QR Code on each product to evaluate.':
    'El día del concurso, escanea el código QR de cada producto para evaluar.',
  'Almost there!': '¡Ya casi!',
  "The competition phase hasn't started yet — wait for the organizer to begin.":
    'La fase del concurso aún no ha comenzado — espera a que el organizador la inicie.',
  "As soon as the phase starts, you'll be able to scan QR Codes to evaluate.":
    'En cuanto comience la fase, podrás escanear los códigos QR para evaluar.',
  'All caught up!': '¡Todo al día!',
  "There's no active evaluation phase right now. See you in the next contest!":
    'No hay ninguna fase de evaluación activa por ahora. ¡Nos vemos en el próximo concurso!',
  'Thank you for your participation': 'Gracias por tu participación',
  'Your schedule has been completed.': 'Tu agenda ya fue finalizada.',
  'My Judge Profile': 'Mis Datos de Jurado',
  'Your table': 'Tu mesa',
  'Lead Judge': 'Juez Líder',
  "Point the camera at the product's QR Code. The evaluation form opens automatically when detected.":
    'Apunta la cámara al código QR del producto. La ficha de evaluación se abre automáticamente al detectar.',
  'Try again': 'Intentar de nuevo',
  'Enable camera': 'Activar cámara',
  'Tap “Enable camera” to allow access. If nothing happens, check the camera permission for this site.':
    'Toca “Activar cámara” para permitir el acceso. Si no pasa nada, revisa el permiso de cámara de este sitio.',
  'Black image? Switch camera': '¿Imagen en negro? Cambiar cámara',
  'Camera': 'Cámara',
  'The camera is being used by another app. Close it and try again.':
    'La cámara está siendo usada por otra app. Ciérrala e inténtalo de nuevo.',
  'No camera was found on this device.': 'No se encontró ninguna cámara en este dispositivo.',
  'Could not start the camera. Check the permission and that no other app is using it.':
    'No se pudo iniciar la cámara. Verifica el permiso y que ninguna otra app la esté usando.',
  'The camera only works over a secure connection (https).': 'La cámara solo funciona con una conexión segura (https).',
  'Camera access is blocked. Tap the lock/menu icon next to the address bar, open Permissions and allow the Camera, then reload the page.':
    'El acceso a la cámara está bloqueado. Toca el ícono de candado/menú junto a la barra de direcciones, abre Permisos, permite la Cámara y recarga la página.',
  'Product characteristics': 'Características del producto',
  'Comments': 'Comentarios',
  'Comment is required for the lead judge.': 'El comentario es obligatorio para el juez líder.',
  'General observations about the product...': 'Observaciones generales sobre el producto...',
  "Lead judge feedback — register the table's consolidated impression about this product.":
    'Feedback del juez líder — registra la impresión consolidada de la mesa sobre este producto.',
  'characters': 'caracteres',
  'All evaluations done!': '¡Todas las evaluaciones listas!',
  'You finished evaluating every product on your tables.': 'Has terminado de evaluar todos los productos de tus mesas.',
  'Thank you for your work!': '¡Gracias por tu trabajo!',
  'You are evaluating as Lead Judge': 'Estás evaluando como Juez Líder',
  'If you have any questions, please contact the organizer.':
    'Si tienes alguna duda, ponte en contacto con el organizador.',
  'Completed': 'Completado',
  'Progress': 'Progreso',
  'registration': 'registro',
  'Scan Product': 'Escanear producto',
  'Table Code': 'Código de mesa',
  'Curation': 'Curaduría',
  'Consultant Analysis': 'Análisis del consultor',
  'Download Award Seal': 'Descargar sello de premio',
  // Compartilhar premiação nas redes
  'Share': 'Compartir',
  'Share your award': 'Comparte tu premio',
  'Generating image...': 'Generando imagen...',
  'Award image': 'Imagen del premio',
  'Suggested text': 'Texto sugerido',
  'Copy text': 'Copiar texto',
  'Download image': 'Descargar imagen',
  'Share on LinkedIn': 'Compartir en LinkedIn',
  'Text copied': 'Texto copiado',
  'Could not copy the text': 'No se pudo copiar el texto',
  'Could not open sharing. Download the image instead.': 'No se pudo abrir el menú para compartir. Descarga la imagen.',
  'The award seal is not in a supported format (PNG, JPG, SVG or PDF), so it cannot be shared. Please contact the organizers.':
    'El sello del premio no está en un formato compatible (PNG, JPG, SVG o PDF) y no se puede compartir. Contacta a la organización.',
  'Could not generate the image. Please try again.': 'No se pudo generar la imagen. Inténtalo de nuevo.',
  'The organizer logo could not be loaded, so the image was generated without it.':
    'No se pudo cargar el logo de la organización; la imagen se generó sin él.',
  'For Instagram, post the downloaded image from your phone and paste the copied text in the caption.':
    'Para Instagram, publica la imagen descargada desde tu celular y pega el texto copiado en la descripción.',
  'My product {{produto}} won {{selo}} at {{concurso}} {{ano}}! {{hashtag}}':
    '¡Mi producto {{produto}} ganó {{selo}} en el {{concurso}} {{ano}}! {{hashtag}}',
  'Your Judge Certificate': 'Su Certificado de Juez',
  'Your certificate is ready': 'Su certificado está listo',
  'Download your certificate to print or save.': 'Descargue su certificado para imprimir o guardar.',
  'View Certificate': 'Ver Certificado',
  'Downloading...': 'Descargando...',
  'Could not download the certificate. Please try again later.':
    'No se pudo descargar el certificado. Por favor, inténtelo más tarde.',
  'Reviewed': 'Revisado',
  'Download Consultant Analysis': 'Descargar análisis del consultor',
  'Active Producers': 'Productores Activos',
  'Active Foreign Producers': 'Productores Extranjeros Activos',
  'Approved Judges': 'Jueces Aprobados',
  'Total registered judges': 'Total de jueces registrados',
  'Total registered users': 'Total de usuarios registrados',
  'Total Registered Products': 'Total de Productos Registrados',
  'Received Products': 'Productos Recibidos',
  'Products in Analysis': 'Productos en Análisis',
  'Products pending approval': 'Productos pendientes de aprobación',
  'Approved Products': 'Productos Aprobados',
  'Failed Products': 'Productos Rechazados',
  'Products in Transit': 'Productos en Tránsito',
  'Transfered Products': 'Productos transferidos',
  'Separated Products': 'Productos Separados',
  'Total active producers': 'Productores Activos Totales',
  'Product Characteristics': 'Características del producto',
  'Add Characteristic': 'Añadir Característica',
  'Type': 'Tipo',
  'Ordering': 'Orden',
  'Characteristics': 'Características',
  'Edit Characteristic': 'Editar Característica',
  'New Characteristic': 'Nueva Característica',
  'Text': 'Texto',
  'Minimum Value': 'Valor Mínimo',
  'Maximum Value': 'Valor Máximo',
  'Value': 'Valor',
  'Active Category': 'Categoria Activa',
  'Characteristic': 'Característica',
  'Next': 'Próximo',
  'Leite': 'Leche',
  'Tipo de Leite': 'Tipo de la Leche',
  'Leite Cru': 'Leche Crudo',
  'Leite Pasteurizado': 'Leche Pasteurizado',
  'Your cateogry is': 'Su categoría es',
  'Reset': 'Reiniciar',
  'Values': 'Valores',
  'Change': 'Cambiar',
  'Casca': 'Corteza',
  'Tratamento da Massa': 'Tratamiento de masa',
  'Maturação': 'Maduración',
  'Leite de Vaca': 'Leche de Vaca',
  'Leite de Cabra': 'Leche de Cabra',
  'Leite de Ovelha': 'Leche de Oveja',
  'Leite de Búfala': 'Leche de Búfala',
  'Maturado': 'Madurado',
  'Massa filada': 'Masa hilada',
  'Massa não filada': 'Masa no hilada',
  'Não se aplica': 'No se aplica',
  'by': 'por',
  'Criado': 'Creado',
  'Pago': 'Pago',
  'Aprovado': 'Aprobado',
  'Avaliado': 'Avaliado',
  'Total Paid Products': 'Total de Productos Pagados',
  'Reprocess': 'Reprocesar',
  'Confirms category duplication': 'Confirma duplicación de categoría',
  'Available': 'Disponible',
  'Has counter evidence': 'Tiene contraprueba',
  'Add Selected Judges': 'Añadir Jueces Seleccionados',
  'Phase updated successfully': 'Fase actualizada con éxito.',
  'Phase registred successfully': 'Fase registrada con éxito.',
  'Repeat Judges': 'Repetir Juecezes',
  'New Contest Phase': 'Nueva Fase del Concurso',
  'Edit Contest Phase': 'Editar Fase del Concurso',
  'Add New Phase': 'Añadir Nueva Fase',
  'Started': 'Iniciado',
  'In Progress': 'En Curso',
  'Counting Votes': 'Contando Votos',
  'Number of Products': '# de Productos',
  'Coupons': 'Cupóns',
  'Coupon': 'Cupón',
  'Discount Type': 'Tipo de descuento',
  'Quantity': 'Cantidad',
  'Quantity Left': 'Cantidad Restante',
  'Start Date': 'Fecha de Inicio',
  'End Date': 'Fecha Final',
  'Add Coupon': 'Añadir Cupón',
  'New Coupon': 'Nuevo Cupón',
  'Porcentage': 'Porcentage',
  'Money': 'Diñero',
  'Edit Coupon': 'Editar Cupón',
  'Milk coagulation day': 'Día de la coagulación de la leche',
  'Discount': 'Descuento',
  'Total with Discounts': 'Total con Descuentos',
  'Cupom inválido': 'Cupón inválido',
  'Apply Coupon': 'Aplicar Cupón',
  'Copied to clipboard': 'Copiado',
  'Declassify Product': 'Desclasificar Producto',
  'Justification': 'Justificación',
  'Product declassified successfully': 'Producto desclasificado con éxito',
  'Paid with coupon': 'Pago hecho con cupón',
  'Confirm Payment': 'Confirmar Pago',
  'All': 'Todos',
  'Expired': 'Vencida',
  'Awaiting Payment': 'Aguardando Pago',
  'Start Expiring Date': 'Fecha de Vencimiento de Inicio',
  'End Expiring Date': 'Fecha de Vencimiento de Fin',
  'Finished': 'Finalizado',
  'Attach Photographic Record': 'Adjuntar Registro Fotográfico',
  'Award Phase': 'Fase Premiada',
  'Last Contest Phase': 'Última Fase del Concurso',
  'Not Started': 'No Ha Comenzado',
  'Qualified': 'Clasificado',
  'Justification of Declassification': 'Justificación de la Desclasificación',
  'Technical Advisor': 'Asesor Técnico',
  'Date of Birth': 'Fecha de Nacimiento',
  'Address': 'Dirección',
  'Number': 'Número',
  'Complement': 'Complemento',
  'Neighborhood': 'Barrio',
  'Print by Podium': 'Imprimir por Podio',
  'Print All Certificates': 'Imprimir Todos los Certificados',
  'Reset Status': 'Volver para el estado inicial',
  'Restrictions': 'Restricciones',
  'Available Products': 'Productos Disponibles',
  'table': 'mesa',
  'Add Table': 'Añadir Mesa',
  'Approval': 'Aprobación',
  'Generate PDF': 'Generar PDF',
  'Access your account': 'Accede a tu cuenta',
  'Update': 'Actualizar',
  'Account': 'Cuenta',
  'Select Client': 'Seleccione el Cliente',
  'wizard.back': 'Atr\u00e1s',
  'wizard.continue': 'Continuar',
  'wizard.next': 'Siguiente',
  'wizard.steps.0': 'Datos de la Cuenta',
  'wizard.steps.1': 'Elegir Concurso',
  'wizard.steps.2': 'Registro',
  'wizard.steps.3': 'Conclusi\u00f3n',
  'wizard.step1.title': 'Configuraci\u00f3n de la cuenta',
  'wizard.step1.subtitle': 'Selecciona tu idioma preferido y acepta los t\u00e9rminos para continuar.',
  'wizard.step1.idiomaLabel': 'Idioma preferido',
  'wizard.step1.lgpd.title': 'T\u00e9rminos de Uso y Pol\u00edtica de Privacidad',
  'wizard.step1.lgpd.body':
    'Al utilizar nuestro sistema, aceptas los t\u00e9rminos de uso y la pol\u00edtica de privacidad. Tus datos personales ser\u00e1n procesados exclusivamente para los fines descritos en nuestra pol\u00edtica, incluyendo el env\u00edo de comunicaciones y encuestas en nombre del organizador del concurso.',
  'wizard.step1.lgpd.link': 'Ver pol\u00edtica completa \u2197',
  'wizard.step1.lgpd.agree':
    'He le\u00eddo y acepto los <b>T\u00e9rminos de Uso</b> y la <b>Pol\u00edtica de Privacidad</b>',
  'wizard.step2.title': 'Elige tu concurso',
  'wizard.step2.subtitle': 'Selecciona el concurso en el que deseas participar.',
  'wizard.step2.noConcursos':
    'No hay concursos con inscripciones abiertas en este momento. Contacta al organizador para m\u00e1s informaci\u00f3n.',
  'wizard.step2.inscricoes': 'Inscripciones',
  'wizard.step2.evento': 'Evento',
  'wizard.step2.gratuito': 'Gratuito',
  'wizard.step2.valor': 'Cuota de inscripci\u00f3n',
  'wizard.step3.title': 'Completa tu registro',
  'wizard.step3.subtitle': 'Completa los datos a continuaci\u00f3n para finalizar tu registro como productor.',
  'wizard.step4.title': '\u00a1Registro completado!',
  'wizard.step4.subtitle':
    'Tu registro en <b>{{nomeConcurso}}</b> fue completado con \u00e9xito. Ahora puedes registrar tus productos o acceder al panel.',
  'wizard.step4.inscreverproduto': 'Registrar primer producto',
  'wizard.step4.irpainel': 'Ir al panel',
  'wizard.jurado.step2.label': 'Registro',
  'wizard.jurado.step2.title': 'Completa tu registro como jurado',
  'wizard.jurado.step2.subtitle': 'Completa los datos a continuación para finalizar tu registro como jurado.',
  'wizard.jurado.step3.title': '¡Registro completado!',
  'wizard.jurado.step3.subtitle': 'Tu registro como jurado ha sido completado. Ya puedes acceder a tu panel.',
  'wizard.jurado.step3.irpainel': 'Ir al panel de jurado',
  'wizard.jurado.erroCarregarFormulario': 'Error al cargar el formulario de registro. Por favor, inténtalo de nuevo.',
  'resultados.titulo': 'Resultados del Concurso',
  'resultados.todos': 'Todos los Grupos',
  'resultados.semConcursoAtivo': 'No se encontró ningún concurso activo.',
  'resultados.semResultados': 'Aún no se han publicado resultados.',
  'resultados.erroCarregar': 'Error al cargar los resultados. Por favor, inténtalo de nuevo.',
  'resultados.produto.titulo': 'Resultado de Mi Producto',
  'resultados.produto.voltar': 'Volver',
  'resultados.produto.naoEncontrado': 'No se encontró resultado para este producto.',
  'resultados.produto.notasPorCriterio': 'Notas por Criterio',
  'Contest Results': 'Resultados del Concurso',
  'Language preference not saved. Please try again.': 'No se pudo guardar el idioma. Por favor, inténtalo de nuevo.',
  // Curador
  'Curator': 'Curador',
  // Convite de Jurado
  'convite.titulo': 'Invitación de Jurado',
  'convite.cabecalho': 'Has sido invitado a ser Jurado',
  'convite.descricao': 'Al aceptar, serás redirigido para crear tu cuenta y acceder al concurso como jurado.',
  'convite.aceitar': 'Aceptar Invitación',
  'convite.recusar': 'Rechazar',
  'convite.confirmarRecusaTitulo': 'Rechazar Invitación',
  'convite.confirmarRecusaTexto':
    '¿Estás seguro de que quieres rechazar esta invitación? Esta acción no se puede deshacer.',
  'convite.confirmarRecusa': 'Sí, rechazar',
  'convite.voltar': 'Volver',
  'convite.recusadoTitulo': 'Invitación rechazada.',
  'convite.recusadoSubtitulo': 'Has rechazado la invitación de jurado. Puedes cerrar esta página.',
  'convite.erroRecusar': 'Error al rechazar la invitación. Por favor, inténtalo de nuevo.',
  // Inscripción de Producto
  'inscricao.nova.titulo': 'Inscripción de Producto',
  'inscricao.nova.tituloCurto': 'Nueva Inscripción',
  'inscricao.nova.breadcrumb': 'Inscripciones',
  'inscricao.nova.passo.classificacao': 'Clasificación',
  'inscricao.nova.passo.dados': 'Datos del Producto',
  'inscricao.nova.secao.categorias': 'Categorías de producto',
  'inscricao.nova.secao.dados': 'Datos del producto',
  'inscricao.nova.campoObrigatorio': 'Campo obligatorio',
  'inscricao.nova.classificada.titulo': '¡Producto registrado!',
  'inscricao.nova.refazer': 'Rehacer',
  'inscricao.nova.wizard.erroCarga': 'No se pudo iniciar la clasificación.',
  'inscricao.nova.wizard.tentarNovamente': 'Intentar de nuevo',
  'inscricao.nova.wizard.semMatch.titulo': 'Ninguna categoría encontrada',
  'inscricao.nova.wizard.refazerClassificacao': 'Rehacer clasificación',
  'inscricao.nova.wizard.multiplosResultados':
    'Encontramos más de una opción. Elige la que mejor describe tu producto:',
  'inscricao.nova.wizard.aguarde': 'Por favor, espere...',
  'inscricao.nova.wizard.avancar': 'Siguiente',
  'inscricao.nova.wizard.etapa': 'Etapa',
  'inscricao.nova.wizard.certificado': 'Certificado',
  'inscricao.nova.direto.semGrupos': 'No hay grupos disponibles para selección directa en este concurso.',
  'inscricao.nova.direto.label': 'Seleccione la categoría del producto',
  'inscricao.nova.direto.placeholder': 'Buscar por categoría, subcategoría o grupo...',
  'inscricao.nova.direto.semOpcoes': 'Ningún grupo encontrado',
  'inscricao.nova.tabs.wizard': 'Asistente (recomendado)',
  'inscricao.nova.tabs.direto': 'Selección directa',
  'inscricao.nova.classificadoAlertPre': 'Producto clasificado en',
  'inscricao.nova.classificadoAlertPos': 'Haz clic en',
  'inscricao.nova.classificadoAlertPos3': 'para continuar.',
  'inscricao.nova.categoriaSelecionada': 'Categoría seleccionada',
  'inscricao.nova.form.identificacao': 'Identificación',
  'inscricao.nova.form.nome': 'Nombre del producto *',
  'inscricao.nova.form.nomeObrigatorio': 'El nombre del producto es obligatorio',
  'inscricao.nova.form.nomePlaceholder': 'Ej.: nombre que aparecerá en el certificado',
  'inscricao.nova.form.caracteristicas': 'Características del producto',
  'inscricao.nova.form.camposObrigatorios': 'Complete todos los campos obligatorios marcados con *.',
  'inscricao.nova.acoes.cancelar': 'Cancelar',
  'inscricao.nova.acoes.voltar': 'Volver',
  'inscricao.nova.acoes.proximaEtapa': 'Siguiente etapa',
  'inscricao.nova.acoes.inscrevendo': 'Inscribiendo...',
  'inscricao.nova.acoes.inscrever': 'Inscribir Producto',
  'inscricao.nova.erroCarga': 'No se pudo cargar la información del concurso. Por favor, inténtelo de nuevo.',
  'inscricao.nova.erroSubmit': 'Error al inscribir el producto. Verifica los datos e inténtalo de nuevo.',
  'inscricao.nova.feedback.sucesso': '¡Producto inscrito con éxito!',
  'inscricao.nova.feedback.verProdutos': 'Ver mis productos',
  // Campos do formulário de produtor (por código)
  'campo.nome': 'Nombre',
  'campo.nome_completo': 'Nombre completo',
  'campo.nome_fazenda': 'Nombre de la granja',
  'campo.representante_legal': 'Representante legal',
  'campo.cpf': 'CPF',
  'campo.cnpj': 'CNPJ',
  'campo.rg': 'RG',
  'campo.passaporte': 'Pasaporte',
  'campo.tipo_documento': 'Tipo de documento',
  'campo.email': 'Correo electrónico',
  'campo.celular': 'Teléfono celular',
  'campo.telefone': 'Número de teléfono',
  'campo.pais': 'País',
  'campo.cidade': 'Ciudad',
  'campo.estado': 'Estado',
  'campo.cep': 'Código postal',
  'campo.search_cep': 'Buscar Código Postal',
  'campo.endereco_logradouro': 'Dirección',
  'campo.endereco_numero': 'Número',
  'campo.endereco_complemento': 'Complemento',
  'campo.endereco_bairro': 'Barrio',
  'campo.endereco_cidade': 'Ciudad',
  'campo.endereco_uf': 'Estado',
  'campo.website': 'Sitio web',
  'campo.data_nascimento': 'Fecha de nacimiento',
  'campo.siapp': 'Número SIAPP',
  'campo.servico_sanitario': 'Certificado sanitario',
  'campo.numero_servico_sanitario': 'Número de servicio sanitario',
  'campo.aceite_lgpd': 'Consentimiento de protección de datos',
  'campo.aceite_termos': 'Términos de servicio',
  'campo.aceite_imagem': 'Autorización de uso de imagen',
  'My Producer Profile': 'Mi Perfil de Productor',
  'Performance Report': 'Informe de Desempeño',
  'Download PDF': 'Descargar PDF',
  'Generating...': 'Generando...',
  'Judge opinion': 'Dictamen',
  'Justify your scores — required in this phase.': 'Justifique sus notas — obligatorio en esta fase.',
  'Opinion is required in this phase.': 'El dictamen es obligatorio en esta fase.',
  'Open file {{nome}}': 'Abrir {{nome}}',
  'Panel opinions': 'Dictámenes del jurado',
  // Avaliação remota: a mesa aparece pro jurado como "Banca"
  'Panel {{n}}': 'Panel {{n}}',
  'Voting until {{date}}': 'Votación hasta {{date}}',
  'Read more': 'Leer más',
  'Read less': 'Leer menos',
  'Voting closed on {{date}}': 'Votación cerrada el {{date}}',
  'Panel not assigned yet': 'Panel aún no asignado',
  'Panel': 'Panel',
  'Your panel': 'Tu panel',
  'Back to my panels': 'Volver a mis paneles',
  'Back to panel': 'Volver al panel',
  'All products evaluated in this panel!': '¡Todos los productos evaluados en este panel!',
  'No products assigned to this panel yet.': 'Aún no hay productos asignados a este panel.',
  'As soon as the phase starts, the products to evaluate will appear here.':
    'En cuanto comience la fase, los productos a evaluar aparecerán aquí.',
  'You finished evaluating every product on your panels.':
    'Has terminado de evaluar todos los productos de tus paneles.',
  'Opinion {{n}}': 'Dictamen {{n}}',
  'Click <b>New Registration</b> to register your first product.':
    'Haga clic en <b>Nueva Inscripción</b> para registrar su primer producto.',
  'this product': 'este producto',
  'This product has not been evaluated in any finalized phase yet.':
    'Este producto aún no ha sido evaluado en ninguna fase finalizada.',
  'Reject': 'Reprobar',
  'Rejected': 'Reprobado',
  'Approve or reject this product.': 'Aprueba o reprueba este producto.',
  'Choose Approve or Reject.': 'Elige Aprobar o Reprobar.',
  'Favorite': 'Favorito',
  'Mark as favorite': 'Marcar como favorito',
  'Remove from favorites': 'Quitar de favoritos',
  'Choose up to {{k}} favorites among the products you evaluate. You can change your choice until the deadline.':
    'Elige hasta {{k}} favoritos entre los productos que evalúas. Puedes cambiar tu elección hasta el plazo.',
  '{{n}} of {{k}} favorites chosen': '{{n}} de {{k}} favoritos elegidos',
  'You have already chosen {{k}} favorites. Remove one to choose another.':
    'Ya elegiste {{k}} favoritos. Quita uno para elegir otro.',
  'Save vote': 'Guardar voto',
  'Vote saved!': '¡Voto guardado!',
  'Justify your vote — required in this phase.': 'Justifica tu voto — obligatorio en esta fase.',
  'Favorites chosen': 'Favoritos elegidos',
  'Approval rate': '% de aprobación',
  'Votes': 'Votos',
  'votes': 'votos',
  'Popular vote': 'Voto popular',
  'Could not load the vote. Try again in a few minutes.':
    'No fue posible cargar la votación. Inténtalo de nuevo en unos minutos.',
  'Voting starts on {{date}}': 'La votación empieza el {{date}}',
  'Vote until {{date}}': 'Vota hasta el {{date}}',
  'There is no popular vote in this contest right now.': 'No hay votación popular en este concurso por ahora.',
  'Voting is closed. Thank you for taking part!': 'La votación está cerrada. ¡Gracias por participar!',
  'vote': 'voto',
  'You voted': 'Votaste',
  'Vote': 'Votar',
  'Something went wrong. Try again.': 'Algo salió mal. Inténtalo de nuevo.',
  'Vote confirmed!': '¡Voto confirmado!',
  'Vote for {{name}}': 'Votar por {{name}}',
  'I have read and accept the rules of the popular vote': 'Leí y acepto el reglamento de la votación popular',
  'Hide rules': 'Ocultar reglamento',
  'Read the rules': 'Leer el reglamento',
  'We sent a code to {{email}}. It is valid for 15 minutes — check your spam folder too.':
    'Enviamos un código a {{email}}. Es válido por 15 minutos — revisa también la carpeta de spam.',
  'Resend code in {{s}}s': 'Reenviar código en {{s}}s',
  'Resend code': 'Reenviar código',
  'Change e-mail': 'Cambiar e-mail',
  'Your vote for {{name}} was counted. Thank you!': 'Tu voto por {{name}} fue registrado. ¡Gracias!',
  'Send code': 'Enviar código',
  'Confirm vote': 'Confirmar voto',
  'Popular vote is open — vote for your favorite': 'La votación popular está abierta — vota por tu favorito',
  'Poor': 'Malo',
  'Excellent': 'Excelente',
  'Final score (jury + public)': 'Nota final (jurado + público)',
  'Public {{nota}} (popular vote only)': 'Público {{nota}} (solo voto popular)',
  'Jury {{juri}} × {{pj}}% + Public {{publico}} × {{pp}}%': 'Jurado {{juri}} × {{pj}}% + Público {{publico}} × {{pp}}%',
  '{{n}} public vote': '{{n}} voto del público',
  '{{n}} public votes': '{{n}} votos del público',
  'Page not found': 'Página no encontrada',
  "Oops! This page didn't make the podium.": '¡Ups! Esta página se quedó fuera del podio.',
  'The address may have changed or the link is incomplete. How about going back and trying again?':
    'La dirección puede haber cambiado o el enlace está incompleto. ¿Qué tal volver e intentarlo de nuevo?',
  'Go to the home page': 'Ir al inicio',
  'Previous page': 'Página anterior',
  'Error 404': 'Error 404',
  'Access closed': 'Acceso finalizado',
  'This platform is no longer available. For questions, please contact the organizer.': 'Esta plataforma ya no está disponible. Si tienes dudas, comunícate con la organización.',
  'In this vote you vote through the QR code available at each place.':
    'En esta votación se vota por el código QR disponible en cada lugar.',
  'Your evaluation': 'Tu evaluación',
  'Your vote': 'Tu voto',
  'This candidate is not in a popular vote right now.': 'Este candidato no está en votación popular por ahora.',
  'You have already voted for this candidate on this device.': 'Ya votaste por este candidato en este dispositivo.',
  'Choose up to {{k}} favorites in each category.': 'Elige hasta {{k}} favoritos en cada categoría.',
  'Choose up to {{k}} favorites.': 'Elige hasta {{k}} favoritos.',
  'Choose your favorite in each category.': 'Elige tu favorito en cada categoría.',
  'Choose your favorite.': 'Elige tu favorito.',
  'Rate each candidate you try — one evaluation per person for each candidate.':
    'Califica a cada candidato que evalúes — una evaluación por persona para cada candidato.',
  'Approve or reject each candidate — one evaluation per person for each candidate.':
    'Aprueba o reprueba a cada candidato — una evaluación por persona para cada candidato.',
  'The limit renews every day.': 'El límite se renueva cada día.',
  'Each vote is confirmed by a code sent to your e-mail.': 'Cada voto se confirma con un código enviado a tu e-mail.',
  'evaluation': 'evaluación',
  'approval': 'aprobación',
  'Evaluate': 'Evaluar',
  'Evaluate {{name}}': 'Evaluar {{name}}',
  'We will send a 6-digit code to your e-mail to confirm the vote. Your data is used only to validate the vote.':
    'Enviaremos un código de 6 dígitos a tu e-mail para confirmar el voto. Tus datos solo se usan para validar el voto.',
  'CPF (optional)': 'CPF (opcional)',
  'Continue': 'Continuar',
  'See all candidates': 'Ver todos los candidatos',
  // Visual novo (shell/auth no padrão do konq-backoffice)
  'Menu': 'Menú',
  'Contests': 'Concursos',
  'Judge invitation': 'Invitación de juez',
  'Use the email {{email}} to create your account.': 'Usa el correo {{email}} para crear tu cuenta.',
  'Pending approval': 'Aprobación pendiente',
  'Your judge invitation is under review. You will be notified as soon as your participation is confirmed.':
    'Tu invitación como juez está en análisis. Te avisaremos en cuanto se confirme tu participación.',
  'products registered': 'productos inscritos',
  'auth.tagline.title': 'Excelencia que merece ser reconocida',
  'auth.tagline.subtitle':
    'Inscribe tus productos, sigue las evaluaciones y celebra tus logros — todo en un solo lugar.',
  'Download lab analysis report': 'Descargar informe del análisis de laboratorio',
  'Until {{date}}': 'Hasta el {{date}}',
  'termos.organizadorPadrao': 'el organizador del concurso',
  'termos.lgpd.tratamento':
    'En cumplimiento de la Ley brasileña n.º 13.709/2018 (Ley General de Protección de Datos Personales — LGPD) y demás normas aplicables, autorizo de forma libre, informada e inequívoca a {{organizador}} a tratar mis datos personales para las finalidades de este concurso: inscripción y evaluación de los productos, comunicaciones sobre el concurso, atención de solicitudes y encuestas de interés del organizador, así como el uso de mi imagen y voz en fotos, documentos y otros medios de comunicación para campañas promocionales e institucionales.',
  'termos.lgpd.compartilhamento':
    'Al registrarme, autorizo que los resultados de los análisis de laboratorio y mis datos se compartan <b>SOLO</b> con los representantes de {{organizador}} que integran la comisión técnica del concurso, y declaro estar de acuerdo y cumplir con todos los términos del reglamento.',
  'termos.imagem.titulo': 'Autorización de uso de imagen',
  'termos.imagem.aceitar': 'Estoy de acuerdo',
  'termos.imagem.texto':
    'Yo, {{nome}}, portador(a) del documento de identidad (RG) n.º {{rg}} y del CPF n.º {{cpf}}, autorizo el uso de mi imagen y voz en acciones de marketing, divulgación, redes sociales y demás piezas publicitarias que sean necesarias, incluso impresas o por cualquier medio de divulgación, para uso exclusivo de {{organizador}} y por tiempo indeterminado.',
  'landing.inscricoes': 'Inscripciones',
  'landing.entrar': 'Iniciar sesión',
  'landing.cadastrar': 'Registrarse',
  'landing.hero.titulo': 'Inscribe tu producto.<br/>Conquista tu lugar.',
  'landing.inscricoesAbertas': 'Inscripciones abiertas',
  'landing.encerradas.titulo': 'Las inscripciones están cerradas por ahora',
  'landing.encerradas.texto': 'Contacta al organizador para conocer los próximos concursos.',
  'landing.privacidade': 'Política de Privacidad',
  'landing.card.periodoInscricoes': 'Período de inscripción',
  'landing.card.dataEvento': 'Fecha del evento',
  'landing.card.taxa': 'Tasa de inscripción',
  'landing.card.gratuito': 'Gratis',
  'landing.card.participar': 'Participar',
  'landing.hero.subtitulo':
    'Participa en los concursos disponibles, inscribe tus productos y sigue los resultados en tiempo real.',
  'Ouro': 'Oro',
  'Prata': 'Plata',
  'Bronze': 'Bronce',
  'resultados.produto.pontos': '{{nota}} pts',
  'resultados.produto.semCriterios': 'No hay criterios disponibles.',
  'resultados.produto.criterio': 'Criterio',
  'resultados.produto.notaMedia': 'Nota media',
  'resultados.produto.maximo': 'Máximo',
  'resultados.produto.desempenho': 'Desempeño',
  'convite.naoEncontrado': 'Invitación no encontrada.',
  'convite.expirado': 'Esta invitación ha expirado.',
  'convite.jaAceito': 'Esta invitación ya fue aceptada.',
  'convite.revogado': 'Esta invitación fue revocada.',
  'convite.erroBuscar': 'No fue posible cargar la invitación. Inténtalo de nuevo.',
  'convite.carregando': 'Cargando invitación...',
  'convite.invalido': 'Invitación no válida',
  'convite.cabecalhoNomeado': '{{nome}}, has sido invitado a ser Juez',
  'arquivo.erroUpload': 'Error al subir el archivo.',
  'arquivo.erroAbrir': 'No se pudo abrir el archivo.',
  'arquivo.enviando': 'Subiendo...',
  'arquivo.substituir': 'Reemplazar archivo',
  'arquivo.selecionar': 'Seleccionar archivo',
  'arquivo.ate': 'hasta {{mb}}MB',
  'arquivo.multiplos': 'varios archivos',
  'arquivo.um': '1 archivo',
  'arquivo.abrir': 'Abrir',
  'arquivo.remover': 'Eliminar',
  'data.aPartirDe': 'La fecha debe ser a partir del {{date}}',
  'data.ateDia': 'La fecha debe ser hasta el {{date}}',
  'data.invalida': 'Fecha no válida',
  'validacao.cnpjInvalido': 'CNPJ no válido',
  'validacao.cpfInvalido': 'CPF no válido',
  'validacao.cpfErroVerificar': 'Error al verificar el CPF.',
  'validacao.erroSalvarCadastro': 'Error al guardar el registro.',
  'validacao.camposFaltando': 'Campos obligatorios sin completar: {{campos}}',
  // Pente fino de i18n (textos que estavam fixos no código)
  'erroFatal.titulo': 'Algo salió mal',
  'erroFatal.texto':
    'Encontramos un problema inesperado. El error se informó automáticamente y nuestro equipo lo está investigando.',
  'erroFatal.detalhes': 'Detalles técnicos',
  'erroFatal.tentarNovamente': 'Intentar de nuevo',
  'erroFatal.recarregar': 'Recargar la página',
  'semAcessoTenant.titulo': 'Sin acceso a este concurso',
  'semAcessoTenant.texto':
    'Tu cuenta no tiene acceso al concurso <b>{{slug}}</b>. Verifica que ingresaste con el correo correcto o pide acceso al organizador.',
  'validacao.cnpjJaCadastradoProdutor': 'CNPJ ya registrado por otro productor.',
  'validacao.cpfJaCadastradoProdutor': 'CPF ya registrado por otro productor.',
  'validacao.cadastroSalvo': '¡Registro guardado con éxito!',
  'validacao.linkInvalido.titulo': 'Enlace de registro inválido',
  'validacao.linkInvalido.texto':
    'Accede al enlace de registro proporcionado por el organizador del concurso para continuar.',
  'checkout.titulo': 'Pago de la inscripción',
  'checkout.passos.resumo': 'Resumen',
  'checkout.passos.cupom': 'Cupón',
  'checkout.passos.pagamento': 'Pago',
  'checkout.passos.confirmacao': 'Confirmación',
  'checkout.formas.pix': 'Pix',
  'checkout.formas.boleto': 'Boleto bancario',
  'checkout.erroCarregar': 'Error al cargar los datos de la inscripción.',
  'checkout.cupomInvalido': 'Cupón inválido o no aplicable.',
  'checkout.erroGerarFatura': 'Error al generar la factura. Inténtalo de nuevo.',
  'checkout.desabilitado': 'El pago no está habilitado para este concurso.',
  'checkout.resumoPedido': 'Resumen del pedido',
  'checkout.taxaPorProduto': 'Tarifa por producto',
  'checkout.produtosInscritos': 'Productos inscritos',
  'checkout.total': 'Total',
  'checkout.cupomDesconto': 'Cupón de descuento',
  'checkout.codigoCupom': 'Código del cupón',
  'checkout.aplicar': 'Aplicar',
  'checkout.descontoAplicado': '¡Descuento de {{desconto}} aplicado! Nuevo total: {{total}}',
  'checkout.continuarComDesconto': 'Continuar con descuento',
  'checkout.pular': 'Omitir',
  'checkout.formaPagamento': 'Forma de pago',
  'checkout.selecione': 'Selecciona',
  'checkout.subtotal': 'Subtotal',
  'checkout.descontoCupom': 'Descuento (cupón)',
  'checkout.totalAPagar': 'Total a pagar',
  'checkout.confirmarPagamento': 'Confirmar pago',
  'checkout.pagamentoConfirmado': '¡Pago confirmado!',
  'checkout.pedido': 'Pedido: {{numero}}',
  'checkout.irParaInscricao': 'Ir a mi inscripción',
  'checkout.vencido': 'Pago vencido. Genera una nueva factura.',
  'checkout.tentarNovamente': 'Intentar de nuevo',
  'checkout.aguardandoPagamento': 'Esperando el pago',
  'checkout.pendente': 'Pendiente',
  'checkout.pixCopiaECola': 'Pix copiar y pegar',
  'checkout.copiarPix': 'Copiar código Pix',
  'checkout.codigoBarras': 'Código de barras',
  'checkout.copiarCodigoBarras': 'Copiar código de barras',
  'checkout.abrirBoleto': 'Abrir boleto',
  'Winner': 'Ganador',
  'desempenho.fasesAvaliadas_one': '{{count}} fase evaluada',
  'desempenho.fasesAvaliadas_other': '{{count}} fases evaluadas',
  'desempenho.erroRelatorio': 'No se pudo cargar el informe de desempeño.',
  'desempenho.erroCarregar': 'No se pudo cargar el desempeño.',
  'ficha.titulo': 'Ficha de envío del producto',
  'ficha.codigoProduto': 'Código del producto',
  'ficha.caracteristicas': 'Características del producto',
  'ficha.instrucoes.titulo': 'Instrucciones',
  'ficha.instrucoes.1': '1. Imprime esta ficha y pégala de forma visible en el embalaje del producto.',
  'ficha.instrucoes.2': '2. El código <b>{{codigo}}</b> es único e identifica este producto durante todo el concurso.',
  'ficha.instrucoes.3':
    '3. El código QR permite al operador localizar y actualizar este producto rápidamente en cualquier etapa.',
  'ficha.instrucoes.4': '4. Mantén la ficha intacta hasta el final de la evaluación.',
  'ficha.rodape': 'Konq · Plataforma de Concursos',
  'ficha.umProduto': 'un producto de',
  'ficha.preparando': 'Preparando ficha...',
  'Subcontest': 'Subconcurso',
  'Seal URL not found': 'No se encontró el archivo del sello',
  'Error loading seal for printing': 'Error al cargar el sello',
  'Product description': 'Descripción del producto',
  'Loading...': 'Cargando...',
  'No transitions registered.': 'No hay movimientos registrados.',
  'Download Seal': 'Descargar sello',
  'Product name': 'Nombre del producto',
  'Name is required': 'El nombre es obligatorio',
  'Description is required': 'La descripción es obligatoria',
  'cert.baixar': 'Descargar certificado',
  'inscricao.nova.direto.variacao': 'Variación',
  'inscricao.nova.form.descricao': 'Descripción del producto',
  'inscricao.nova.form.descricaoObrigatoria': 'La descripción es obligatoria',
  'inscricao.nova.form.descricaoPlaceholder': 'Lote, información adicional...',
  'treinamento.produto': 'Producto de entrenamiento {{n}}',
  'treinamento.categoria': 'Categoría de entrenamiento',
  'treinamento.atributos.aparencia.nome': 'Apariencia',
  'treinamento.atributos.aparencia.descricao': 'Evalúa la apariencia visual del producto.',
  'treinamento.atributos.aroma.nome': 'Aroma',
  'treinamento.atributos.aroma.descricao': 'Evalúa el aroma característico.',
  'treinamento.atributos.sabor.nome': 'Sabor',
  'treinamento.atributos.sabor.descricao': 'Evalúa el sabor predominante.',
  'treinamento.atributos.textura.nome': 'Textura',
  'treinamento.atributos.textura.descricao': 'Evalúa la textura y la consistencia.',
  'treinamento.atributos.apresentacao.nome': 'Presentación',
  'treinamento.atributos.apresentacao.descricao': 'Evalúa la presentación general.',
  'resultados.semResultadosCategoria': 'No hay resultados publicados para esta categoría.',
  'resultados.produto.lugar': '{{posicao}}.º lugar',
  'resultados.produto.deTotal': 'de {{total}}',
  'perfil.estado.conviteJuradoPendente': 'Invitación de jurado pendiente',
  'perfil.estado.produtorSemInscricao': 'Productor (sin inscripción)',
  'erro.operacao': 'Error al ejecutar la operación',
  'Training available': 'Entrenamiento disponible',
  'Start training': 'Iniciar entrenamiento',
  'Practice evaluation with a simulated list of products. Nothing is sent to the server.':
    'Practica la evaluación con productos de prueba. Tus notas no cuentan en el concurso real.',
  'Training Table': 'Mesa de entrenamiento',
  'Scan the QR code shown by the instructor or tap a product to open the form.':
    'Escanea el código QR proyectado por el instructor o toca un producto para abrir la ficha.',
  'Simulated evaluation. Nothing is sent to the server.':
    'Esta es una evaluación de entrenamiento — no cuenta en el concurso real.',
  'Reset training? Local saved evaluations will be removed.':
    '¿Reiniciar el entrenamiento? Se borrarán todas tus notas de entrenamiento.',
  'Training product not found.': 'Producto de entrenamiento no encontrado.',
  'Back to training': 'Volver al entrenamiento',
  'Training evaluation saved on this device.': '¡Evaluación de entrenamiento guardada!',
  'Save training evaluation': 'Guardar evaluación',
  'Out of range': 'Fuera de rango',
  'Disqualify this product': 'Descalificar este producto',
  'Disqualification reason': 'Motivo de la descalificación',
  'Required': 'Obligatorio',
  'Total': 'Total',
  'Access as': 'Acceder como',
  'Choose a real user to impersonate. All actions persist as that user — be careful.':
    'Elige un usuario real para acceder como él. Todas las acciones quedan registradas a su nombre — úsalo con cuidado.',
  'No active contest for this tenant.': 'No hay concurso vigente en este tenant.',
  'Could not load the active contest.': 'No se pudo cargar el concurso vigente.',
  'Search by name or email…': 'Buscar por nombre o correo…',
  'No results.': 'Sin resultados.',
  'Could not load the list. Try again.': 'No se pudo cargar la lista. Inténtalo de nuevo.',
  'Impersonate': 'Acceder como',
  'Showing the first 50 judges. Use search to filter.':
    'Mostrando los primeros 50 jurados. Usa la búsqueda para filtrar.',
  'Showing the first 50 producers. Use search to filter.':
    'Mostrando los primeros 50 productores. Usa la búsqueda para filtrar.',
  'Impersonating': 'Accediendo como',
  'as Judge': '(Jurado)',
  'as Producer': '(Productor)',
  'Exit impersonation': 'Salir',
  'Produtor': 'Productor',
  'Jurado': 'Jurado',
  'Curador': 'Curador',
  'Administrador': 'Administrador',
  'Viewing as {{nome}}: this profile is read-only.': 'Viendo como {{nome}}: este perfil es solo de lectura.',
  'cadastro.erroCarregarFormulario': 'Error al cargar el formulario de registro. Inténtalo de nuevo.',
  'validacao.cnpjErroVerificar': 'Error al verificar el CNPJ.',
  'My evaluations': 'Mis evaluaciones',
  'validacao.campoObrigatorio': 'Campo obligatorio',
};

export default es;
